// src/layouts/LayoutPrivado.jsx

import Navbar from "../components/Navbar";
import BottomNavBar from "../components/BottomNavBar";

export default function LayoutPrivado({ children }) {
  return (
    // Agregamos la clase `overflow-x-hidden` aquí.
    <div className="min-h-screen transition-colors duration-300 overflow-x-hidden
      bg-gradient-to-br from-blue-100 via-white to-green-100
      dark:from-gray-900 dark:via-gray-950 dark:to-gray-900
      text-black dark:text-white pb-24 lg:pb-6"
    >
      <Navbar />
      <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {children}
      </main>
      <BottomNavBar />
    </div>
  );
}